defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/ViewMyClubs',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Models/PlayTogetherClub',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/HelpButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PageWrapper',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubsList',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/NoClubs',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardFlowHeader'
  ],
  function (Component, PlayTogetherDictionary, Utils, PlayTogetherApi, PlayTogetherClubModel, Loader, HelpButton, CtaButton, PageWrapper, ClubsList, NoClubs, CardFlowHeader) {

    // Component:
    Component('view-my-clubs', [PlayTogetherDictionary], function (m, route, settings) {

      // Components:
      var root = {
        controller: function () {
          this.rootDictionary = PlayTogetherDictionary;
          this.dictionary = this.rootDictionary.get.bind({ prefix: 'ViewMyClubs/' });
          this.helpOverlayDictionary = PlayTogetherDictionary.get.bind({ prefix: 'ViewMyClubs/HelpOverlay/' });
          this.helpOverlayCloseButtonText = PlayTogetherDictionary.get('Shared/CloseButton');

          this.settings = settings;
          this.navigationPaths = this.settings.navigation;
          this.isLoading = m.prop(true);
          this.error = m.prop(null);
          this.clubs = m.prop([]);
          this.currentUser = m.prop(null);
          this.shortenPlayerName = Utils.shortenPlayerName;

          PlayTogetherApi.getAllClubs({
            includePlayers: true,
            includeActiveGroupPlays: true
          }, true).then((response) => {
            const myClubs = response.groups.map((club) => {
              return new PlayTogetherClubModel(club);
            });

            this.clubs(myClubs);
            this.currentUser(response.player);
            this.isLoading(false);
            m.redraw();
          }, (response) => {
            this.error(response);
            this.isLoading(false);
            m.redraw();
          });

          // Add event listener for redireting on user logout
          Utils.redirectOnLogout(this.navigationPaths.redirectOnLogoutPage);
          Utils.checkLoginStatus();
        },

        view: function (controller) {
          // Loading:
          if (controller.isLoading()) {
            return Loader(controller);
          }

          if (controller.error()) {
            return PageWrapper({
              $content: m('.play-together__blocked-page-text', controller.error())
            });
          }

          const $pageHeader = {
            title: controller.dictionary('PageTitle'),
            subtitle: controller.dictionary('PageDescription'),
            className: 'justified-content',
            actions: [
              CardFlowHeader({
                goBack: () => {
                  window.history.back();
                },
                helpOverlay: {
                  title: controller.helpOverlayDictionary('Title'),
                  description: controller.helpOverlayDictionary('Description'),
                  closeButtonLabel: controller.helpOverlayCloseButtonText,
                }
              })]
          };

          const $pageContent = controller.clubs().length > 0 ? ClubsList(controller) : NoClubs(controller);

          return [
            PageWrapper({
              $header: $pageHeader,
              $content: $pageContent,
              $footer: m('div', CtaButton({
                text: controller.dictionary('CreateClubButton'),
                href: controller.navigationPaths.createClubPage,
                options: ['medium']
              }))
            })
          ];
        }
      };

      // Routes:
      route('/', root);
    });

  });
